export interface PowerPreset {
  id: string;
  base: number;
  exponent: number;
}

export const POWER_PRESETS: readonly PowerPreset[] = [
  { id: 'two-pow-four', base: 2, exponent: 4 },
  { id: 'two-pow-ten', base: 2, exponent: 10 },
  { id: 'three-pow-three', base: 3, exponent: 3 },
  { id: 'ten-pow-six', base: 10, exponent: 6 },
];
